"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InstantResultSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')({
    height: 'calc(100% - 55px)',
    width: '100%'
});
const InstantResultRow = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3, 0),
        borderBottom: "1px solid ".concat(theme.palette.divider),
        display: 'grid',
        gridTemplateAreas: "\n    'deliveryMethodTag'\n    'pickupPointInfo'\n    'shippingFee'\n    'additionalInfo'",
        '&:last-child': {
            borderBottom: 0
        },
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'space-between',
            gridTemplateAreas: "\n    'deliveryMethodTag shippingFee'\n    'pickupPointInfo shippingFee'\n    'additionalInfo shippingFee'"
        }
    };
});
const InstantResultText = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gridArea: 'pickupPointInfo'
    };
});
const SkeletonText = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(0.5)
    };
});
const DeliveryMethodTag = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'deliveryMethodTag',
        marginBottom: theme.spacing(2)
    };
});
const AdditionalInfo = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'additionalInfo',
        [theme.breakpoints.up('sm')]: {
            margin: theme.spacing(2, 0, 0)
        }
    };
});
const ShippingFee = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'shippingFee',
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(2, 0, 0)
        }
    };
});
const InstantResultSkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        "data-testid": getTestId(_models.TestId.InstantResultSkeleton),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InstantResultRow, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeliveryMethodTag, {
                        animation: "wave",
                        variant: "text",
                        width: 100,
                        height: 25
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InstantResultText, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                                animation: "wave",
                                variant: "text",
                                width: 180,
                                height: 21
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                                animation: "wave",
                                variant: "text",
                                width: 180,
                                height: 21
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                                animation: "wave",
                                variant: "text",
                                width: 180,
                                height: 21
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShippingFee, {
                        animation: "wave",
                        variant: "text",
                        width: 50,
                        height: 21
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdditionalInfo, {
                        animation: "wave",
                        variant: "text",
                        width: 250,
                        height: 21
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InstantResultRow, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeliveryMethodTag, {
                        animation: "wave",
                        variant: "text",
                        width: 100,
                        height: 25
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InstantResultText, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                                animation: "wave",
                                variant: "text",
                                width: 180,
                                height: 21
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                                animation: "wave",
                                variant: "text",
                                width: 180,
                                height: 21
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
                                animation: "wave",
                                variant: "text",
                                width: 180,
                                height: 21
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShippingFee, {
                        animation: "wave",
                        variant: "text",
                        width: 50,
                        height: 21
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdditionalInfo, {
                        animation: "wave",
                        variant: "text",
                        width: 250,
                        height: 21
                    })
                ]
            })
        ]
    });
};
exports.InstantResultSkeleton = InstantResultSkeleton;
